import { cva } from "cva";
import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import { TagToClassNameMap } from "~/lib/shared/html-utils";
import { FullWidthImage } from "~/ui-library";

export type FloatingImageWithTextProps = {
  bodyText: string;
  imageAlt: string;
  imageFloatDirection: "Left" | "Right";
  imageCaption: string;
  imageSrc: string;
  mobileImageSrc: string;
  imageWidth: number;
  imageHeight: number;
};

const floatingContainerStyles = cva(
  "mb-s h-auto w-full md:mb-0 md:max-w-[50%]",
  {
    variants: {
      imageFloatDirection: {
        Left: "float-left md:pr-m lg:pr-l",
        Right: "float-right md:pl-m lg:pl-l",
      },
    },
  }
);

const tagToClassNameMap: TagToClassNameMap = new Map([["p", "mb-s"]]);

export const FloatingImageWithText: React.FC<FloatingImageWithTextProps> = ({
  bodyText,
  imageAlt,
  imageFloatDirection,
  imageSrc,
  imageHeight,
  imageWidth,
}) => (
  <>
    <div>
      <div className={floatingContainerStyles({ imageFloatDirection })}>
        <FullWidthImage
          alt={imageAlt}
          className="block w-full md:mr-l"
          src={imageSrc}
          height={imageHeight}
          width={imageWidth}
        />
      </div>
      <div>
        <div className="text-body-large leading-body">
          <BuildHTML html={bodyText} tagToClassNameMap={tagToClassNameMap} />
        </div>
        <div />
      </div>
    </div>
  </>
);
